var _ellipse, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstaIcon2(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4779",
    "data-name": "Group 4779",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.685,
    height: 26.685,
    viewBox: "0 0 26.685 26.685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 2.557,
    cy: 2.557,
    rx: 2.557,
    ry: 2.557,
    transform: "translate(10.786 11.048)",
    fill: "#ffd6ec"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M33.759,24.137a2.557,2.557,0,0,0-1.475-1.475,4.262,4.262,0,0,0-1.442-.262H24.613a4.262,4.262,0,0,0-1.442.262A2.557,2.557,0,0,0,21.7,24.137a4.262,4.262,0,0,0-.262,1.442c-.033.82-.033,1.049-.033,3.114s0,2.295.033,3.114a4.262,4.262,0,0,0,.262,1.442,2.557,2.557,0,0,0,1.475,1.475,4.262,4.262,0,0,0,1.442.262h6.229a4.262,4.262,0,0,0,1.442-.262,2.557,2.557,0,0,0,1.475-1.475,4.262,4.262,0,0,0,.262-1.442c.033-.82.033-1.049.033-3.114s0-2.295-.033-3.114a4.262,4.262,0,0,0-.262-1.442Zm-6.032,8.491a3.967,3.967,0,1,1,3.967-3.967A3.967,3.967,0,0,1,27.727,32.628Zm4.131-7.147a.918.918,0,1,1,.918-.918A.918.918,0,0,1,31.858,25.482Z",
    transform: "translate(-14.384 -15.057)",
    fill: "#ffd6ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M13.343,0A13.343,13.343,0,1,0,26.685,13.343,13.343,13.343,0,0,0,13.343,0Zm7.671,16.785a5.671,5.671,0,0,1-.361,1.869,3.934,3.934,0,0,1-2.262,2.262,5.671,5.671,0,0,1-1.869.361h-6.36a5.671,5.671,0,0,1-1.869-.361,3.934,3.934,0,0,1-2.262-2.262,5.671,5.671,0,0,1-.361-1.869c-.033-.82-.033-1.082-.033-3.18s0-2.36.033-3.18a5.671,5.671,0,0,1,.361-1.869A3.934,3.934,0,0,1,8.294,6.294a5.671,5.671,0,0,1,1.869-.328h6.36a5.671,5.671,0,0,1,1.869.361,3.934,3.934,0,0,1,2.262,2.229,5.671,5.671,0,0,1,.361,1.869c.033.82.033,1.082.033,3.18S21.047,15.965,21.014,16.785Z",
    fill: "#ffd6ec"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon2);
export default __webpack_public_path__ + "static/media/insta_icon2.c59f408b3b8df2b78306e1ab125ac9cd.svg";
export { ForwardRef as ReactComponent };